// 地图配置文件
export const mapConfig = {
  // 天地图密钥
  tianDiTuKey: '6696bb85542195d53c585abf032d4ba4'//'28e91b65fc82acb6f9ed4394a4b72486' //'6696bb85542195d53c585abf032d4ba4'//
}

export default mapConfig